import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import Select from "commons/ui/input/Select";
import SwitchInput from "commons/ui/input/SwitchInput";
import WysiwygSimpleEditor from "commons/ui/input/WysiwygSimpleEditor";
import Paper from "commons/ui/Paper";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import OrderableImages from "components/subComponents/OrderableImages";
import AttachmentPicker from "components/ui/AttachmentPicker";

import useProjectsForm from "hooks/form/useProjectsForm";
import useProjectCategories from "hooks/useProjectCategories";

import { DesktopOrMobile } from "types/enums";

function ProjectsForm() {
    const { setDesktopMobileImage, orderableImagesHook, formHook } = useProjectsForm();

    const { checkErrorVisibility, setValue, form } = formHook;

    const projectCategories = useProjectCategories();

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Impostazioni</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-5"}>
                            <Select
                                label={"Categoria"}
                                setValue={setValue}
                                options={projectCategories}
                                value={form.category}
                                path={"category"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-5"}>
                            <InputText
                                label={"Luogo"}
                                value={form.place}
                                setValue={setValue}
                                path={"place"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-2"}>
                            <SwitchInput
                                checked={form.enabled}
                                label={"Area pubblica"}
                                setValue={setValue}
                                path={"enabled"}
                                alignedToForm
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-5"}>
                            <InputText
                                label={"Slug"}
                                value={form.slug}
                                setValue={setValue}
                                path={"slug"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Thumbnail</h2>
                        </GridItem>
                    </GridRow>

                    <ExtensionsProporsionInfo
                        desktopText={"Desktop: 600x338px (max 60KB)"}
                        mobileText={"Mobile: 400x225px (max 50KB)"}
                        proportion={"16:9"}
                    />

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Desktop"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.desktop)
                                }
                                file={form.cover_img.desktop}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("cover_img.desktop")}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Mobile"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.mobile)
                                }
                                file={form.cover_img.mobile}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("cover_img.mobile")}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                setValue={setValue}
                                value={form.text.it.title}
                                path={"text.it.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione"}
                                bigDefault={true}
                                value={form.text.it.description}
                                path={"text.it.description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>
                </GridColumn>

                <GridColumn>
                    <GridRow>
                        <GridItem className={"title-margin"}>
                            <h2>Immagini</h2>
                        </GridItem>
                    </GridRow>

                    <ExtensionsProporsionInfo proportion={"16:9"} />
                </GridColumn>

                <OrderableImages orderableImagesHook={orderableImagesHook} />
            </Paper>
        </GridColumn>
    );
}

export default ProjectsForm;
